import { FC } from "react";

import { StyledPermissionFieldGroup, StyledPermissionFieldGroupProps } from "./styles";

type PermissionFieldGroupProps = StyledPermissionFieldGroupProps;

export const PermissionFieldGroup: FC<PermissionFieldGroupProps> = ({ children, ...rest }) => {
  return <StyledPermissionFieldGroup {...rest}>{children}</StyledPermissionFieldGroup>;
};
